import React from "react";
import * as Tabs from "@radix-ui/react-tabs";
import styled from "styled-components";
import Information from "./Information";
import Documentation from "./Documentation";
import MessageToRequestor from "./MessageToRequestor";
import Vaccination from "./Vaccination";
import ToolTip from "../reuse/ToolTip";

const TabList = styled(Tabs.List)`
  display: flex;
  border-bottom: 2px solid ${({ theme }) => theme.branding.borderColor};
  margin-bottom: 16px;
  overflow-x: auto;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.branding.color};
`;

const Tab = styled(Tabs.Trigger)`
  padding: 12px 24px;
  cursor: pointer;
  font-weight: 600;
  border: none;
  background: none;
  outline: none;
  transition:
    color 0.3s,
    background-color 0.3s;

  font-size: 18px;
  color: rgb(32, 41, 79);

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &[data-state="active"] {
    color: ${({ theme }) => theme.colors.primary};
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
  }
`;

function TabsContent({ request }) {
  const status = request?.currentStatus_F;

  return (
    <>
      <MessageToRequestor
        requestorId={request?.id_F}
        messageInformation={request?.messageInformation_F}
        messageToRequestor={request?.messageToRequestor_F}
      />

      <Tabs.Root defaultValue="information">
        <TabList aria-label="Tabs" color="orange">
          <Tab value="information" data-tooltip-id="information">
            Information
          </Tab>
          <ToolTip text="Información" id="information" />
          {status === "Open" && (
            <Tab value="documentation" data-tooltip-id="documentation">
              Documentation
            </Tab>
          )}
          <ToolTip text="Documentación" id="documentation" />
          {status === "Ready" && (
            <Tab value="vaccination" data-tooltip-id="vaccination">
              Vaccination
            </Tab>
          )}
          <ToolTip text="Vacunación" id="vaccination" />
        </TabList>
        <>
          <Tabs.Content value="information">
            <Information requestRecord={request} />
          </Tabs.Content>
          {status === "Open" && (
            <Tabs.Content value="documentation">
              <Documentation requestRecord={request} />
            </Tabs.Content>
          )}
          {status === "Ready" && (
            <Tabs.Content value="vaccination">
              <Vaccination requestRecord={request} />
            </Tabs.Content>
          )}
        </>
      </Tabs.Root>
    </>
  );
}

export default TabsContent;
